export const SUPPORT_EMAIL = 'app.toolip.contact@gmail.com';

export const COMPANY_SNAPSHOT = [
  {
    label: 'Platform',
    value: 'Desktop workflow toolbelt',
  },
  {
    label: 'Built by',
    value: 'One independent developer',
  },
  {
    label: 'Support',
    value: 'Direct contact with the developer',
  },
];

export const OPERATING_PRINCIPLES = [
  {
    title: 'Personal by design',
    description:
      'Toolip is a personal project, not a faceless software brand. The product, design, fixes, and direction all come from one person staying close to the work.',
  },
  {
    title: 'Built with intention',
    description:
      'Every feature has to earn its place. The focus stays on practical utilities, fast access, and customization that actually improves a daily workflow.',
  },
  {
    title: 'Worth supporting',
    description:
      'Supporting Toolip means supporting an independent developer who is actively building, maintaining, and improving the product directly.',
  },
];

export const EXPLORE_LINKS = [
  {
    title: 'Features',
    route: '/features',
    eyebrow: 'Product',
    description: 'Browse the tool categories and see what ships inside Toolip.',
  },
  {
    title: 'Updates',
    route: '/updates',
    eyebrow: 'Progress',
    description: 'Follow product milestones, polish work, and what is shipping next.',
  },
  {
    title: 'About',
    route: '/about',
    eyebrow: 'Company',
    description: 'Meet the solo developer behind Toolip and the independent spirit behind the product.',
  },
  {
    title: 'Pricing',
    route: '/pricing',
    eyebrow: 'Plans',
    description: 'See the free, plus, and team plans without digging through the app.',
  },
  {
    title: 'Contact',
    route: '/contact',
    eyebrow: 'Support',
    description: 'Get a direct line for product questions, bugs, or business inquiries.',
  },
];

export const UPDATE_LOG = [
  {
    title: 'Public release groundwork',
    date: 'March 2026',
    summary: 'The site now emphasizes distribution, pricing, updates, and product trust signals in one place.',
    bullets: [
      'Homepage refreshed to surface real pages instead of acting like a single landing screen.',
      'Navigation reorganized around product, company, and support paths.',
      'Company copy adjusted to match an independent one-person studio honestly.',
    ],
  },
  {
    title: 'Feedback and account flows',
    date: 'Late 2025',
    summary: 'Account, feedback, consent, and billing flows were expanded so visitors can see the business side is real and active.',
    bullets: [
      'Feedback collection added for signed-in users.',
      'Pricing and subscription management connected to Stripe and Firebase.',
      'Analytics events scoped around major navigation and conversion actions.',
    ],
  },
  {
    title: 'Core product positioning',
    date: '2025',
    summary: 'The product direction settled around a desktop toolbelt with modular widgets, customization, and team-ready pricing.',
    bullets: [
      'Feature catalog and team information pages introduced.',
      'Download flow connected to GitHub releases.',
      'Tool catalog shaped around concise daily-use utilities.',
    ],
  },
];

export const FAQ_ITEMS = [
  {
    question: 'Why does the website stay fairly compact?',
    answer:
      'Because every page should earn its keep. Toolip aims to feel established without creating a maze of empty marketing pages that would go stale.',
  },
  {
    question: 'Is Toolip a large company?',
    answer:
      'No. Toolip is a solo software business built and run by one person, and that independent-maker approach is a core part of the product.',
  },
  {
    question: 'Where should a new visitor go after the homepage?',
    answer:
      'Most people will want Features, Pricing, Updates, or About first, so those are treated as the core supporting pages.',
  },
];
